export default __webpack_public_path__ + "static/graph-7ef4442ef2bf6ee2f8fe18260cd8de93.svg";